export default "__VITE_ASSET__CsecEN9r__"